"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _web3Utils = _interopRequireDefault(require("web3-utils"));

var _contract = _interopRequireDefault(require("./contract"));

var _utils = require("../utils");

var _Liability = _interopRequireDefault([{
  constant: true,
  inputs: [],
  name: "lighthouseFee",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x051064c6"
}, {
  constant: true,
  inputs: [],
  name: "model",
  outputs: [{
    name: "",
    type: "bytes"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x0ad9d052"
}, {
  constant: true,
  inputs: [],
  name: "isSuccess",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x0b6c754b"
}, {
  constant: true,
  inputs: [],
  name: "cost",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x13faede6"
}, {
  constant: true,
  inputs: [],
  name: "objective",
  outputs: [{
    name: "",
    type: "bytes"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x14f1586a"
}, {
  constant: true,
  inputs: [],
  name: "xrt",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x330f9588"
}, {
  constant: true,
  inputs: [],
  name: "validator",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x3a5381b5"
}, {
  constant: true,
  inputs: [],
  name: "validatorFee",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x3f6d8256"
}, {
  constant: true,
  inputs: [],
  name: "promisee",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x474ce872"
}, {
  constant: true,
  inputs: [],
  name: "lighthouse",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x6301fd63"
}, {
  constant: true,
  inputs: [],
  name: "result",
  outputs: [{
    name: "",
    type: "bytes"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x65372147"
}, {
  constant: true,
  inputs: [],
  name: "offerHash",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x699373ca"
}, {
  constant: true,
  inputs: [],
  name: "isFinalized",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x8d4e4083"
}, {
  constant: true,
  inputs: [],
  name: "promisor",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xc2d8de54"
}, {
  constant: true,
  inputs: [],
  name: "factory",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xc45a0155"
}, {
  constant: true,
  inputs: [],
  name: "demandHash",
  outputs: [{
    name: "",
    type: "bytes32"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xf0476bc5"
}, {
  constant: true,
  inputs: [],
  name: "token",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xfc0c546a"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "success",
    type: "bool"
  }, {
    indexed: false,
    name: "result",
    type: "bytes"
  }],
  name: "Finalized",
  type: "event",
  signature: "0x7d5242f52c478159b4963f0898012c593d0786bfa3bce2e9bb2f073b068caee0"
}, {
  constant: false,
  inputs: [{
    name: "_xrt",
    type: "address"
  }],
  name: "setup",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x66d38203"
}, {
  constant: false,
  inputs: [{
    name: "_model",
    type: "bytes"
  }, {
    name: "_objective",
    type: "bytes"
  }, {
    name: "_token",
    type: "address"
  }, {
    name: "_cost",
    type: "uint256"
  }, {
    name: "_lighthouse",
    type: "address"
  }, {
    name: "_validator",
    type: "address"
  }, {
    name: "_validator_fee",
    type: "uint256"
  }, {
    name: "_deadline",
    type: "uint256"
  }, {
    name: "_sender",
    type: "address"
  }, {
    name: "_signature",
    type: "bytes"
  }],
  name: "demand",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x48a984e4"
}, {
  constant: false,
  inputs: [{
    name: "_model",
    type: "bytes"
  }, {
    name: "_objective",
    type: "bytes"
  }, {
    name: "_token",
    type: "address"
  }, {
    name: "_cost",
    type: "uint256"
  }, {
    name: "_validator",
    type: "address"
  }, {
    name: "_lighthouse",
    type: "address"
  }, {
    name: "_lighthouse_fee",
    type: "uint256"
  }, {
    name: "_deadline",
    type: "uint256"
  }, {
    name: "_sender",
    type: "address"
  }, {
    name: "_signature",
    type: "bytes"
  }],
  name: "offer",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x413781d2"
}, {
  constant: false,
  inputs: [{
    name: "_result",
    type: "bytes"
  }, {
    name: "_success",
    type: "bool"
  }, {
    name: "_signature",
    type: "bytes"
  }],
  name: "finalize",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x4fe6365e"
}]);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Liability = /*#__PURE__*/function (_Contract) {
  _inherits(Liability, _Contract);

  function Liability(web3, address) {
    var _this;

    var worker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "0x0000000000000000000000000000000000000000";

    _classCallCheck(this, Liability);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Liability).call(this, web3, _Liability["default"], address));
    _this.worker = _web3Utils["default"].toChecksumAddress(worker);
    return _this;
  }

  _createClass(Liability, [{
    key: "getInfo",
    value: function getInfo() {
      return Promise.all([this.methods.model().call(), this.methods.objective().call(), this.methods.result().call(), this.methods.token().call(), this.methods.cost().call(), this.methods.lighthouseFee().call(), this.methods.validatorFee().call(), this.methods.demandHash().call(), this.methods.offerHash().call(), this.methods.promisor().call(), this.methods.promisee().call(), this.methods.lighthouse().call(), this.methods.validator().call(), this.methods.isSuccess().call(), this.methods.isFinalized().call()]).then(function (info) {
        return {
          model: (0, _utils.hexToStr)(info[0]),
          objective: (0, _utils.hexToStr)(info[1]),
          result: !info[2] || info[2] === "0x" ? "" : (0, _utils.hexToStr)(info[2]),
          token: info[3],
          cost: Number(info[4]),
          lighthouseFee: Number(info[5]),
          validatorFee: Number(info[6]),
          demandHash: info[7],
          offerHash: info[8],
          promisor: _web3Utils["default"].toChecksumAddress(info[9]),
          promisee: _web3Utils["default"].toChecksumAddress(info[10]),
          lighthouse: _web3Utils["default"].toChecksumAddress(info[11]),
          validator: _web3Utils["default"].toChecksumAddress(info[12]),
          isSuccess: info[13],
          isFinalized: info[14]
        };
      });
    }
  }, {
    key: "lighthouse",
    value: function lighthouse() {
      return this.methods.lighthouse().call().then(function (r) {
        return _web3Utils["default"].toChecksumAddress(r);
      });
    }
  }, {
    key: "result",
    value: function result() {
      return this.methods.result().call().then(function (r) {
        return !r || r === "0x" ? "" : (0, _utils.hexToStr)(r);
      });
    }
  }, {
    key: "model",
    value: function model() {
      return this.methods.model().call().then(function (r) {
        return (0, _utils.hexToStr)(r);
      });
    }
  }, {
    key: "equalDemand",
    value: function equalDemand(hash) {
      return this.methods.demandHash().call().then(function (r) {
        if (hash === r) {
          return true;
        }

        return false;
      });
    }
  }, {
    key: "equalOffer",
    value: function equalOffer(hash) {
      return this.methods.offerHash().call().then(function (r) {
        if (hash === r) {
          return true;
        }

        return false;
      });
    }
  }, {
    key: "onResult",
    value: function onResult() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.once("Finalized", {}, function (error, event) {
          if (error) {
            reject(error);
            return;
          }

          resolve(!event.returnValues.result || event.returnValues.result === "0x" ? "" : (0, _utils.hexToStr)(event.returnValues.result));
        });
      });
    }
  }]);

  return Liability;
}(_contract["default"]);

exports["default"] = Liability;